import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import React from "react";
import {
    AVAILS_DETAIL_DRAWER_COLORS,
    detailDrawerLabelSx,
} from "./availsPlusDetailStyles";

interface DetailCheckboxFieldProps {
    label: string;
    checked: boolean;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
}

/**
 * Checkbox field styled to match outlined Selects in the Avails detail drawer
 * (same height, border, and grid alignment).
 */
export default function DetailCheckboxField({
    label,
    checked,
    disabled = false,
    onChange,
}: DetailCheckboxFieldProps) {
    return (
        <Box sx={{ minWidth: 0 }}>
            <Typography
                variant="caption"
                display="block"
                sx={{ mb: 0.5, ...detailDrawerLabelSx }}
            >
                {label}
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    minHeight: 40,
                    px: 1,
                    borderRadius: 1,
                    border: `1px solid ${AVAILS_DETAIL_DRAWER_COLORS.border}`,
                    bgcolor: "transparent",
                    boxSizing: "border-box",
                    "&:hover": disabled
                        ? undefined
                        : {
                              borderColor: "rgba(255, 255, 255, 0.28)",
                          },
                }}
            >
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={checked}
                            disabled={disabled}
                            onChange={(event) => onChange?.(event.target.checked)}
                            sx={{
                                p: 0.5,
                                color: AVAILS_DETAIL_DRAWER_COLORS.textSecondary,
                                "&.Mui-checked": {
                                    color: AVAILS_DETAIL_DRAWER_COLORS.textPrimary,
                                },
                                "&.Mui-disabled": {
                                    color: "rgba(255, 255, 255, 0.35)",
                                },
                            }}
                        />
                    }
                    label={checked ? "Yes" : "No"}
                    sx={{
                        m: 0,
                        gap: 0.5,
                        color: AVAILS_DETAIL_DRAWER_COLORS.textPrimary,
                        "& .MuiFormControlLabel-label": {
                            fontSize: "0.875rem",
                            color: checked
                                ? AVAILS_DETAIL_DRAWER_COLORS.textPrimary
                                : AVAILS_DETAIL_DRAWER_COLORS.textSecondary,
                        },
                        "&.Mui-disabled .MuiFormControlLabel-label": {
                            color: AVAILS_DETAIL_DRAWER_COLORS.textSecondary,
                        },
                    }}
                />
            </Box>
        </Box>
    );
}
